import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { InspectionsProvider } from './hooks/useInspections';
import { UIProvider } from './hooks/useUI';
import { GamificationProvider } from './hooks/useGamification';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
const APP_VERSION = 'v92';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() === true;
const platform = typeof window !== 'undefined' && window.Capacitor?.getPlatform?.();

console.log(`
╔═══════════════════════════════════════════════════════════════╗
║  TagQuest Fire Safety Scanner                                 ║
║  Version: ${APP_VERSION.padEnd(45)} ║
║  Backend: ${BACKEND_URL.padEnd(45)} ║
║  Platform: ${(isNative ? platform : 'web').padEnd(43)} ║
╚═══════════════════════════════════════════════════════════════╝
`);

const msalInstance = new PublicClientApplication(msalConfig);

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <AuthProvider>
            <InspectionsProvider>
              <UIProvider>
                <GamificationProvider>
                  <App />
                </GamificationProvider>
              </UIProvider>
            </InspectionsProvider>
          </AuthProvider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
}

async function bootstrap() {
  if (isNative) {
    console.log('📱 Native platform detected:', platform);
  }

  try {
    await msalInstance.initialize();
    console.log('🔐 MSAL initialized, current URL:', window.location.href);

    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      console.log('✅ MSAL redirect response handled, account:', response.account?.username);
      if (response.idToken) {
        localStorage.setItem('token', response.idToken);
        console.log('🎫 Token stored in localStorage');
      }
    } else {
      console.log('ℹ️ No MSAL redirect response (normal page load)');
    }
  } catch (error) {
    console.error('❌ MSAL init/redirect error:', error);
    console.error('   Error code:', error.errorCode);
    console.error('   Error message:', error.errorMessage || error.message);
  } finally {
    renderApp();
  }
}

bootstrap();

// Unregister any leftover service workers and clear stale caches.
// The SW was previously registered then disabled, but existing workers
// keep running (and serving cached JS/CSS) until explicitly removed.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => {
      reg.unregister();
      console.log('[PWA] Unregistered stale service worker:', reg.scope);
    });
  });
  if (typeof caches !== 'undefined') {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
        console.log('[PWA] Cleared stale cache:', name);
      });
    });
  }
}
